import { render, staticRenderFns } from "./QuizComponent.vue?vue&type=template&id=28324aa2&scoped=true&"
import script from "./QuizComponent.vue?vue&type=script&lang=js&"
export * from "./QuizComponent.vue?vue&type=script&lang=js&"
import style0 from "./QuizComponent.vue?vue&type=style&index=0&id=28324aa2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28324aa2",
  null
  
)

export default component.exports